/* SARTE LEATHER — sarte-enhance.js: scroll-reveal animations + UI polish helpers */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Shop collection chips: if anything cancels the click, still follow the link ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.shop-nav__chip, a.mobile-shop-nav__chip') : null;
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.defaultPrevented && a.href) window.location.assign(a.href);
  });

  /* ---------- Header shadow once the page scrolls ---------- */
  (function () {
    var hdr = document.querySelector('[data-site-header]');
    if (!hdr) return;
    var tick = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  })();

  /* ---------- Accordion (capture phase, same behaviour as global.js, kept as a safety net) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-accordion-btn]') : null;
    if (!btn) return;
    e.stopPropagation();
    e.preventDefault();

    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var next = !isOpen;
    var group = btn.closest('[data-accordion-group]');

    if (group && group.hasAttribute('data-single-open') && next) {
      Array.prototype.forEach.call(group.querySelectorAll('[data-accordion-btn]'), function (b) {
        if (b === btn) return;
        b.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) {
          if (p.style.maxHeight === 'none') p.style.maxHeight = p.scrollHeight + 'px';
          requestAnimationFrame(function () { p.style.maxHeight = '0px'; });
          p.setAttribute('aria-hidden', 'true');
        }
      });
    }

    btn.setAttribute('aria-expanded', String(next));
    if (panel) {
      if (next) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.setAttribute('aria-hidden', 'false');
      } else {
        if (panel.style.maxHeight === 'none') panel.style.maxHeight = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
        panel.setAttribute('aria-hidden', 'true');
      }
    }
  }, true);

  /* ---------- Staggered reveal on scroll ---------- */
  if (reduce || !('IntersectionObserver' in window)) return;

  var selector = [
    '.section-head', '.product-card', '.trust-strip__item', '.acc-item',
    '.social-grid a', '.category-card', '.trust-card', '.tm-card',
    '.mfg-stat', '.mfg-process-card', '.mfg-material-card', '.mfg-quality-item',
    '.mfg-private-item', '.mfg-gallery-card', '.mfg-faq-item', '.mfg-head', '.mfg-faq-head',
    '.story-chapter', '.story-principle', '.about-principle', '.about-approach__item'
  ].join(',');

  function init() {
    var vh = window.innerHeight || 800;
    var els = Array.prototype.slice.call(document.querySelectorAll(selector));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

    els.forEach(function (el) {
      if (el.classList.contains('reveal') || el.closest('.reveal')) return;
      if (el.getBoundingClientRect().top < vh) return; /* already visible: no flash */
      var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(selector); }) : [];
      var i = Math.max(0, siblings.indexOf(el));
      el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
